// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__29jZ0","actionsCol":"EnrolledClinics_actionsCol__G3u_C"};